import React from 'react';
import ReactDOM from 'react-dom';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';

import CheckoutForm from './checkoutform';

// Make sure to call `loadStripe` outside of a component's render to avoid
// recreating the `Stripe` object on every render.
const stripePromise = loadStripe(
	'pk_test_51K1MfVEYtaUacvEzbyupJVsnjOoqnO6C53UY1x1JkpRDdtHkqclOabWEa417XNmPPogHBizPgy4QHxDRFB91YC9s00GSOtMa8F'
);

const options = {
	mode: 'payment',
	currency: 'usd',
	amount: 1099,
};

function Stripe() {
	return (
		<Elements stripe={stripePromise} options={options}>
			<CheckoutForm />
		</Elements>
	);
}

export default Stripe;
